<template>
	<el-container class="body-container">
		<LeftMenu v-if="$route.meta.showLeftMenu"></LeftMenu>
		<el-container class="main-container">
			<el-header :class="{bread: $route.meta.showBread}" v-if="$route.meta.showNav">
				<Nav></Nav>
				<Bread v-if="$route.meta.showBread"></Bread>
			</el-header>
			<el-main class="body-main" :class="{pad0: !$route.meta.showLeftMenu && !$route.meta.showNav}">
				<div class="container">
					<Content></Content>
				</div>
			</el-main>
		</el-container>
	</el-container>
</template>

<script setup lang="ts">
	import LeftMenu from "@/components/com/LeftMenu"
	import Nav from "@/components/com/Nav"
	import Bread from "@/components/com/Bread"
	import Content from "@/components/com/Content"
	import { useStore } from 'vuex'
	const {dispatch} = useStore()
	
	dispatch('publicOptions/getplatformInfo', 'needload')
	// dispatch('publicOptions/getMenuList')
</script>

<style lang="scss">
	.body-container{
		height: 100vh;
		.el-header{
			padding: 0;
			--el-header-height: 50px;
			--bread-height: 55px;
			&.bread{
				--el-header-height: 105px;
			}
		}
	}
	.body-main{
		padding: 0 20px 10px 25px!important;
	}
	.container{
		background-color: #fff;
		border-radius: 5px;
		padding: 20px 30px;
	}
	.main-container{
		width: 100%;
		overflow-x: hidden;
	}
</style>
